import * as React from 'react';
import { createCalendarPerfDatapoint, logCalendarUsage } from 'owa-shared-analytics';
import { ErrorBoundary, ErrorComponentType } from 'owa-error-boundary';
import { getCurrentThemeId } from 'owa-theme';
import { getIsDarkTheme } from 'owa-fabric-theme';
import { lazyMountAndShowFullOptions } from 'owa-options-view';
import { observer } from 'mobx-react';
import { trace } from 'owa-trace';
import { TxpDatapoint } from 'txp-data';
import TxpWrapper from './TxpWrapper';
import TxpSource from '../store/viewSchema/TxpSource';
import populateTxpDataPointObject from '../utils/telemetry/populateTxpDataPointObject';
import Message from 'owa-service/lib/contract/Message';
import { isFeatureEnabled } from 'owa-feature-flags';

const styles = require('./TxpHeader.scss');

export interface TxpHeaderProps {
    item: Message;
}

@observer
export default class TxpHeader extends React.Component<TxpHeaderProps, any> {
    render() {
        const { item } = this.props;
        return (
            <ErrorBoundary
                child={
                    <TxpWrapper
                        className={styles.txp}
                        owaTheme={getCurrentThemeId()}
                        isDarkTheme={getIsDarkTheme()}
                        entityNamesMap={item.EntityNamesMap}
                        txpBlob={item.TailoredXpEntities}
                        txpStatusBlob={item.TailoredXpEntitiesStatus}
                        ItemId={item.ItemId.Id}
                        InternetMessageId={item.InternetMessageId}
                        calendarEventIds={item.TailoredXpCalendarEventIds}
                        onEventsFromEmailSettingsClicked={this.onEventsFromEmailSettingsClicked}
                        getPerfDatapoint={this.getPerfDatapoint}
                        datapointLogger={this.logTxpDatapoint}
                    />
                }
                onError={this.reportTxpComponentError}
                type={
                    isFeatureEnabled('fwk-devTools')
                        ? ErrorComponentType.Full
                        : ErrorComponentType.None
                }
            />
        );
    }

    private onEventsFromEmailSettingsClicked() {
        lazyMountAndShowFullOptions.importAndExecute('calendar', 'calendarInEmail');
    }

    private logTxpDatapoint(
        datapoint: TxpDatapoint,
        datapointName: string,
        internetMessageId?: string
    ) {
        //Adding source to datapoint object
        datapoint = populateTxpDataPointObject(TxpSource.MailReact.toString(), datapoint);

        logCalendarUsage(datapointName, datapoint, internetMessageId);
    }

    private getPerfDatapoint(datapointName: string) {
        return createCalendarPerfDatapoint(datapointName);
    }

    private reportTxpComponentError(error: Error, errorInfo: React.ErrorInfo) {
        trace.error({
            message: `[TXP] Wrapper Component error: ${error.message}`,
            error: error,
            diagnosticInfo: errorInfo.componentStack,
        });
    }
}
